import { STAGES, STAGES_IDS } from '@app/constants';
import {
  CommentGeneralPrivateAdditional,
  MapDefinition,
  Overview,
} from '@app/interface/assessment';
import { PragmaPowerCategory } from '@app/interface/pragma-power-categories.interface';
import { PragmaPowerDefinition } from '@app/interface/pragma-power-definition.interface';
import { RoleResponse } from '@app/interface/role';
import {
  Valoration as ValorationMock,
  Valoration as ValorationResponse,
} from '@app/interface/valoration-last-assessment.interface';
import { generateLeaderParticipantsMock } from './leader-participants-generate.mock';
import { generatePragmaPowerMock } from './pragmapowers-generate.mock';
import { generateSeniorityLevelsMock } from './seniority-levels-generate.mock';

export const PRAGMAPOWERS_CATEGORIES_INIT: PragmaPowerCategory[] = [
  {
    id: 0,
    name: '',
    state: '',
  },
  {
    id: 0,
    name: '',
    state: '',
  },
  {
    id: 0,
    name: '',
    state: '',
  },
];

export const PRAGMAPOWERS_CATEGORIES: PragmaPowerCategory[] = [
  {
    id: 1,
    name: 'Comunicacion Efectiva',
    state: 'done',
  },
  {
    id: 2,
    name: 'No Trago Entero',
    state: 'done',
  },
  {
    id: 3,
    name: 'Pilotos de nuestro destino',
    state: 'done',
  },
];

export const PRAGMAPOWER_DEFINITION_INIT: PragmaPowerDefinition[] = [];

export const Valoration: Overview = {
  accountName: 'accountName',
  administrativeLeaders: [],
  canSeniorityUp: true,
  comment: null,
  chapter: 'chapter',
  chapterId: '1',
  date: new Date(),
  id: 1,
  experienceTime: '1',
  finishedDate: new Date(),
  isLowerLastAssessmentScore: true,
  isTeamValued: true,
  isTechnicalValued: true,
  leaderEmail: 'leaderEmail',
  level: 'level',
  nextAssessmentDate: null,
  person: 'person',
  pragmaticRole: 'pragmaticRole',
  previousAssessmentScore: 1,
  projectName: 'projectName',
  reviewer: 'reviewer',
  reviewerPhoto: 'reviewerPhoto',
  score: 1,
  selfAssessed: true,
  status: STAGES.Approved,
  seniority: 'seniority',
  seniorityId: '1',
};

export const mockLastValoration: ValorationMock = {
  valoration_id: 16,
  status_assessment_id: 1,
  status_assessment_name: 'Started',
  status_assessment_ia_eva: null,
  ia_eva_assessment_id: null,
  ia_eva_url: null,
  autovaloration: null,
  section_level_id: null,
  section_id: null,
  valorated_section_data: {
    valorated_section_id: 1,
    valorated_section_name: 'Trainee',
    valorated_section_level_id: 1,
    valorated_section_level_name: null,
  },
  leaders_participants: generateLeaderParticipantsMock(
    3,
    2090,
    STAGES_IDS.Pending
  ),
  evaluator_id: 'yojhan.abril@pragma.com.co',
  evaluator_name: 'Yojhan Dario Abril Perez',
  evaluator_photo_url:
    'images/users_avatar/yojhan_abril@pragma_com_co_REDONDA.png',
  chapter_id: 4,
  chapter_name: null,
  speciality_id: 29,
  speciality_name: null,
  technology_id: 16,
  technology_name: null,
  valoration_start_date: '2025-04-10T14:27:26',
  valoration_end_date: null,
  information_pragmatic: {
    valoration_id: 16,
    account_name: null,
    project_name: null,
    leader_mail: null,
    pragmatic_role_account: null,
    time_experience_role: null,
  },
  data_valoration: [
    {
      seniority_id: 1,
      seniority_name: 'Trainee',
      seniority_score: 0.0,
      levels: generateSeniorityLevelsMock(3, 156),
      position: 1,
      pragmapowers: generatePragmaPowerMock(9, 60, true),
      section_map_id: 29,
    },
    {
      seniority_id: 2,
      seniority_name: 'Junior',
      seniority_score: 0.0,
      levels: generateSeniorityLevelsMock(3, 159),
      position: 2,
      pragmapowers: generatePragmaPowerMock(10, 70, true),
      section_map_id: 30,
    },
    {
      seniority_id: 3,
      seniority_name: 'Advanced',
      seniority_score: 0.0,
      levels: generateSeniorityLevelsMock(3, 162),
      position: 3,
      pragmapowers: generatePragmaPowerMock(12, 201, true),
      section_map_id: 31,
    },
    {
      seniority_id: 4,
      seniority_name: 'Senior',
      seniority_score: 0.0,
      levels: generateSeniorityLevelsMock(3, 165),
      position: 4,
      pragmapowers: generatePragmaPowerMock(10, 220, true),
      section_map_id: 32,
    },
    {
      seniority_id: 5,
      seniority_name: 'Master',
      seniority_score: 0.0,
      levels: generateSeniorityLevelsMock(3, 168),
      position: 5,
      pragmapowers: generatePragmaPowerMock(11, 235, true),
      section_map_id: 33,
    },
  ],
  general_scores: [
    {
      score_id: 1,
      is_default: 0,
      score_name: 'No lo ha oído o lo ha oído pero no lo ha usado',
      score_value: 1.0,
      score_scale_id: 1,
      score_scale_name: 'Technical Pragmapowers',
      score_description: null,
      score_scale_description: '',
    },
    {
      score_id: 2,
      is_default: 0,
      score_name:
        'Ha estudiado el tema en cuestión. Conoce teóricamente, sin práctica.',
      score_value: 2.0,
      score_scale_id: 1,
      score_scale_name: 'Technical Pragmapowers',
      score_description: null,
      score_scale_description: '',
    },
    {
      score_id: 3,
      is_default: 0,
      score_name:
        'Realiza laboratorios que le enseñan cómo hacerlo, o lo ha hecho esporádicamente',
      score_value: 3.0,
      score_scale_id: 1,
      score_scale_name: 'Technical Pragmapowers',
      score_description: null,
      score_scale_description: '',
    },
    {
      score_id: 4,
      is_default: 0,
      score_name:
        'Lo ha implementado lo suficiente, por lo tanto tiene un buen dominio del tema',
      score_value: 4.0,
      score_scale_id: 1,
      score_scale_name: 'Technical Pragmapowers',
      score_description: null,
      score_scale_description: '',
    },
    {
      score_id: 5,
      is_default: 0,
      score_name:
        'Habilita a otros en ese comportamiento. Es referente en el tema',
      score_value: 5.0,
      score_scale_id: 1,
      score_scale_name: 'Technical Pragmapowers',
      score_description: null,
      score_scale_description: '',
    },
    {
      score_id: 888,
      is_default: 1,
      score_name: 'otro valor por defecto ',
      score_value: 0.0,
      score_scale_id: null,
      score_scale_name: null,
      score_description: null,
      score_scale_description: null,
    },
    {
      score_id: 999,
      is_default: 1,
      score_name: 'Pendiente por valorar',
      score_value: 0.0,
      score_scale_id: null,
      score_scale_name: null,
      score_description: null,
      score_scale_description: null,
    },
  ],
};

export const mockValorationStatus: ValorationMock = {
  valoration_id: 879,
  status_assessment_id: 1,
  status_assessment_name: 'Started',
  status_assessment_ia_eva: null,
  ia_eva_assessment_id: null,
  ia_eva_url: null,
  autovaloration: null,
  section_level_id: null,
  section_id: null,
  valorated_section_data: {
    valorated_section_id: 0,
    valorated_section_name: null,
    valorated_section_level_id: 0,
    valorated_section_level_name: null,
  },
  leaders_participants: generateLeaderParticipantsMock(
    3,
    2090,
    STAGES_IDS.Pending
  ),
  evaluator_id: 'yojhan.abril@pragma.com.co',
  evaluator_name: 'Yojhan Dario Abril Perez',
  evaluator_photo_url:
    'images/users_avatar/yojhan_abril@pragma_com_co_REDONDA.png',
  chapter_id: 4,
  chapter_name: null,
  speciality_id: 29,
  speciality_name: null,
  technology_id: 16,
  technology_name: null,
  valoration_start_date: '2025-04-04T11:16:25',
  valoration_end_date: null,
  information_pragmatic: {
    valoration_id: 879,
    account_name: 'creci',
    project_name: null,
    leader_mail: null,
    pragmatic_role_account: null,
    time_experience_role: null,
  },
  data_valoration: [
    {
      seniority_id: 1,
      seniority_name: 'Trainee',
      seniority_score: 3.0,
      levels: generateSeniorityLevelsMock(3, 171),
      position: 1,
      pragmapowers: generatePragmaPowerMock(10, 101, false),
      section_map_id: 34,
    },
    {
      seniority_id: 2,
      seniority_name: 'Junior',
      seniority_score: 1.0,
      levels: generateSeniorityLevelsMock(3, 174),
      position: 2,
      pragmapowers: generatePragmaPowerMock(11, 101, false),
      section_map_id: 35,
    },
    {
      seniority_id: 3,
      seniority_name: 'Advanced',
      seniority_score: 1.0,
      levels: generateSeniorityLevelsMock(3, 177),
      position: 3,
      pragmapowers: generatePragmaPowerMock(13, 101, false),
      section_map_id: 36,
    },
    {
      seniority_id: 4,
      seniority_name: 'Senior',
      seniority_score: 3.0,
      levels: generateSeniorityLevelsMock(3, 180),
      position: 4,
      pragmapowers: generatePragmaPowerMock(11, 101, false),
      section_map_id: 37,
    },
    {
      seniority_id: 5,
      seniority_name: 'Master',
      seniority_score: 1.0,
      levels: generateSeniorityLevelsMock(3, 183),
      position: 5,
      pragmapowers: generatePragmaPowerMock(10, 101, false),
      section_map_id: 38,
    },
  ],
  general_scores: [
    {
      score_id: 1,
      score_name: 'No lo ha oído o lo ha oído pero no lo ha usado',
      score_value: 1.0,
      score_scale_id: 1,
      score_scale_name: 'Technical Pragmapowers',
      score_description: null,
      score_scale_description: '',
      is_default: 0,
    },
    {
      score_id: 2,
      score_name:
        'Ha estudiado el tema en cuestión. Conoce teóricamente, sin práctica.',
      score_value: 2.0,
      score_scale_id: 1,
      score_scale_name: 'Technical Pragmapowers',
      score_description: null,
      score_scale_description: '',
      is_default: 0,
    },
    {
      score_id: 3,
      score_name:
        'Realiza laboratorios que le enseñan cómo hacerlo, o lo ha hecho esporádicamente',
      score_value: 3.0,
      score_scale_id: 1,
      score_scale_name: 'Technical Pragmapowers',
      score_description: null,
      score_scale_description: '',
      is_default: 0,
    },
    {
      score_id: 4,
      score_name:
        'Lo ha implementado lo suficiente, por lo tanto tiene un buen dominio del tema',
      score_value: 4.0,
      score_scale_id: 1,
      score_scale_name: 'Technical Pragmapowers',
      score_description: null,
      score_scale_description: '',
      is_default: 0,
    },
    {
      score_id: 5,
      score_name:
        'Habilita a otros en ese comportamiento. Es referente en el tema',
      score_value: 5.0,
      score_scale_id: 1,
      score_scale_name: 'Technical Pragmapowers',
      score_description: null,
      score_scale_description: '',
      is_default: 0,
    },
    {
      score_id: 999,
      score_name: 'Pendiente por valorar',
      score_value: 1.0,
      score_scale_id: 1,
      score_scale_name: 'Technical Pragmapowers',
      score_description: null,
      score_scale_description: '',
      is_default: 0,
    },
  ],
};

export const mockDefiniton: MapDefinition = {
  success: true,
  chapters: {
    page: 0,
    pageSize: 20,
    totalPage: 1,
    data: [
      {
        id: 6,
        chapterSpecialityId: 1,
        seniorityId: 5,
        selfAssessmentEnabled: true,
      },
    ],
  },
};

export const mockCommentGeneralPrivate: CommentGeneralPrivateAdditional = {
  commentId: 1,
  comment: 'Este es un comentario de prueba.',
  commentType: 'general',
  commentatorName: 'Juan Pérez',
  commentatorPhoto: 'https://example.com/photo.jpg',
  commentatorEmail: 'juan.perez@example.com',
  date: '2025-03-06T10:00:00Z',
  seniority: null,
};

export const mockRoleResponse: RoleResponse = {
  chapter_id: 1,
  chapter_name: 'Desarrollo Frontend',
  email: 'usuario@example.com',
  role: [
    { id: 101, name: 'Líder Técnico' },
    { id: 102, name: 'Desarrollador Senior' },
  ],
};

export const mockInitialCurrentValoration: ValorationResponse = {
  valoration_id: 0,
  status_assessment_id: 0,
  status_assessment_name: '',
  status_assessment_ia_eva: null,
  ia_eva_assessment_id: null,
  ia_eva_url: null,
  autovaloration: null,
  section_level_id: null,
  section_id: null,
  valorated_section_data: {
    valorated_section_id: null,
    valorated_section_level_id: null,
    valorated_section_name: '',
    valorated_section_level_name: '',
  },
  leaders_participants: [
    {
      person_id: 2092,
      person_name: 'Cristhian Andres Moreno Velasco',
      image_url:
        'images/users_avatar/cristhian_moreno@pragma_com_co_REDONDA.png',
      email: 'cristhian.moreno@pragma.com.co',
      status_id: STAGES_IDS.Pending,
    },
    {
      person_id: 2100,
      person_name: 'Manuel Alejandro Carrascal Arias',
      image_url:
        'images/users_avatar/manuel_carrascal@pragma_com_co_REDONDA.png',
      email: 'manuel.carrascal@pragma.com.co',
      status_id: STAGES_IDS.Pending,
    },
    {
      person_id: 1770,
      person_name: 'Yusleidy Bernarda Gamboa Cardenas',
      image_url:
        'images/users_avatar/yusleidy_gamboa@pragma_com_co_REDONDA.png',
      email: 'yusleidy.gamboa@pragma.com.co',
      status_id: STAGES_IDS.Pending,
    },
  ],
  evaluator_id: 'yojhan.abril@pragma.com.co',
  evaluator_name: 'Yojhan Dario Abril Perez',
  evaluator_photo_url:
    'images/users_avatar/yojhan_abril@pragma_com_co_REDONDA.png',
  chapter_id: 0,
  chapter_name: '',
  speciality_id: 0,
  speciality_name: '',
  technology_id: 0,
  technology_name: '',
  valoration_start_date: '23-02-10: 11: 11',
  valoration_end_date: '23-02-10: 11: 11',
  autovaloration_start_date: '23-02-10: 11: 11',
  autovaloration_end_date: '23-02-10: 11: 11',
  information_pragmatic: {
    valoration_id: 0,
    account_name: '',
    project_name: '',
    leader_mail: '',
    pragmatic_role_account: '',
    time_experience_role: '',
  },
  data_valoration: [
    {
      seniority_id: 0,
      section_map_id: 0,
      seniority_name: '',
      levels: [
        {
          level_id: 0,
          level_name: '',
          position: 0,
          minimum_value_level: '0',
          maximum_value_level: '0',
        },
      ],
      seniority_score: 0,
      position: 0,
      pragmapowers: [
        {
          pragmapower_id: 0,
          pragmapower_name: '',
          pragmapower_description: '',
          pragmapower_type_id: 0,
          pragmapower_type_name: '',
          pragmapower_score: 0,
          behaviours: [
            {
              behaviour_id: 0,
              behaviour_name: '',
              behaviour_description: '',
              weight: 0,
              position: 0,
              response_valoration_behaviour_id: 0,
              response_behaviour_evaluated: false,
              response_autovaloration_behaviour_id: 0,
              specific_scores: [
                {
                  score_id: 0,
                  score_name: '',
                  score_description: '',
                  score_value: 0,
                  score_scale_id: 0,
                  score_scale_name: '',
                  score_scale_description: '',
                  is_default: 0,
                },
              ],
              assessment_behaviour_id: 0,
            },
          ],
        },
      ],
    },
  ],
  general_scores: [
    {
      score_id: 0,
      score_name: '',
      score_description: '',
      score_value: 0,
      score_scale_id: 0,
      score_scale_name: '',
      score_scale_description: '',
      is_default: 0,
    },
  ],
};
